import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import './TicketMessages.css'
import MessageList from '../MessageList/MessageList';
import NewMessage from '../NewMessage/NewMessage';

const TicketMessages = (props) => {
    const { user, ticket, setTicket, textoRes, setTextoRes, adjuntoRes, setAdjuntoRes, flagAdjuntoRes, setFlagAdjuntoRes, setFlagTextoRes } = props

    let estado;
    switch (ticket.estado) {
        case "CERRADO": estado = "cerrado"; break;
        case "PROCESO": estado = "proceso"; break;
        case "PENDIENTE": estado = "pendiente"; break;
        default: estado = ""; break;
        }

    return (
        <div className={'container-fluid'} style={{height: '100%', display: 'flex', flexDirection: 'column', paddingTop: "15px"}}>
            <div className={`row ${estado}`} style={{height: 'auto', borderRadius: "5px", paddingTop: "5px", paddingBottom: "10px"}}>
                <h3 style={{justifyContent: "center", display: "flex", margin: "5px", fontWeight: "400"}}>{ticket.asunto}</h3>
            </div>
            <hr size = "4px" />
            <div className={'row'} style={{height: '100%', flex: "1"}}>
                <MessageList user = {user} ticket = {ticket}/>
            </div>
            {/*<hr size = "4px" style = {{display: ticket.estado == 'PENDIENTE' || ticket.estado == 'PROCESO' ? '' : 'none'}}/>*/}
            <div className='row' style={{height: '100%', flex: "1", }}>
                <NewMessage user = {user} ticket = {ticket} setTicket = {setTicket} textoRes = {textoRes} setTextoRes = {setTextoRes} adjuntoRes = {adjuntoRes} setAdjuntoRes = {setAdjuntoRes} flagAdjuntoRes={flagAdjuntoRes} setFlagAdjuntoRes={setFlagAdjuntoRes} setFlagTextoRes={setFlagTextoRes}/>
            </div>
        </div>
    )
}

export default TicketMessages;